import HeroSection from "./HeroSection";
import "./HomePage.css";

function HomePage({ onChooseLocation }) {
  return <HeroSection onChooseLocation={onChooseLocation} />;
}

export default HomePage;